class PaczkomatyService {

    constructor($http, $q, SnackbarService) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;
        this.SnackbarService = SnackbarService;
    }

    getStatus() {
        const deferred = this.$q.defer();

        this.$http.get(
            '/ajax/paczkomaty/status/'
        ).then(
            (response) => {
                if (response.data && response.data != '') {
                    deferred.resolve(response.data);
                } else {
                    deferred.resolve([]);
                }
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    loadCities(payOnDelivery = 0) {
        const deferred = this.$q.defer();

        this.$http.get(
            `/ajax/paczkomaty/get_cities/${payOnDelivery}`
        ).then(
            (response) => {
                if (response.data && response.data != '') {
                    deferred.resolve(response.data.map(city => {
                        return {
                            name: city,
                            value: city
                        }
                    }));
                } else {
                    deferred.resolve([]);
                }
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    getMachines(city, payment) {
        const deferred = this.$q.defer();

        this.$http.post(
            `/ajax/paczkomaty/find_machine/${city}`,
            {
                payment_method: payment.id
            }
        ).then(
            (response) => {
                if (response.data && response.data != '') {
                    deferred.resolve(response.data);
                } else {
                    deferred.resolve([]);
                }
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    setMachine(machine) {
        const deferred = this.$q.defer();

        this.$http.get(
            `/ajax/paczkomaty/set_machine/${machine}`,
        ).then(
            (response) => {
                deferred.resolve(machine);
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }

    clear() {
        const deferred = this.$q.defer();

        this.$http.get(
            `/ajax/paczkomaty/clear_machine/`,
        ).then(
            (response) => {
                deferred.resolve(true);
            },
            (response) => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);

                deferred.reject('Wystąpił nieoczekiwany błąd!');
            }
        );

        return deferred.promise;
    }
}

export default PaczkomatyService;